import { createInjectionState } from '@vueuse/core';

export function createInjectionStateOrThrow<Args extends any[], Return>(
  name: string,
  composable: (...args: Args) => Return,
) {
  const [provide, inject] = createInjectionState(composable);

  function injectOrThrow(): Return {
    const context = inject();

    if (!context) {
      throw new Error(
        `Please call "provide${name}" on the appropriate parent component`,
      );
    }

    return context;
  }

  return [provide, injectOrThrow, inject] as const;
}
